import DateFnsUtils from '@date-io/date-fns'
import '@flatsy/utils/translations'
import i18n from '@flatsy/utils/translations'
import '@fullcalendar/react/dist/vdom' // https://github.com/fullcalendar/fullcalendar/issues/6371
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import frLocale from 'date-fns/locale/fr'
import { i18n as i18nType } from 'i18next'
import React from 'react'
import { I18nextProvider } from 'react-i18next'
import { Provider as ReduxProvider } from 'react-redux'
import App from './containers/App'
import store from './redux'

import './index.css'
import './static/assets/fonts/sfpro/font.css'

const Main: React.FC = () => {
  return (
    <I18nextProvider i18n={i18n as i18nType}>
      <ReduxProvider store={store}>
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={frLocale}>
          <App />
        </MuiPickersUtilsProvider>
      </ReduxProvider>
    </I18nextProvider>
  )
}

export default Main
